module.exports = __webpack_public_path__ + "img/voltage.f70c49da.svg";